import * as React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { useState } from "react";

import "../CSS/components/CustomSelect.css";

interface CustomSelectProps {
  type?: string;
  placeholder?: string;
  is_required?: boolean;
  manualError?: boolean;
  errorText?: string;
  value?: string | number | boolean;
  setValue?: (value: number | string) => void;
  onChange?: (event: SelectChangeEvent<string | number>) => void;
  items: { value: string | number | boolean; label: string }[];
  label?: string;
  id?: string;
  inputLabel?: string;
  sx?;
}

const CustomSelect: React.FC<CustomSelectProps> = ({
  type = "text",
  placeholder = "",
  is_required = false,
  manualError = false,
  errorText = "",
  value,
  setValue = () => {},
  onChange = () => {},
  items,
  label = "",
  id = "",
  inputLabel = "",
  sx = {},
  ...props
}) => {
  // const [selectedValue, setSelectedValue] = useState<string | number>("");
  const [touched, setTouched] = useState(false);

  const handleBlur = (event: any) => {
    if (event.target.value === "") {
      setTouched(true);
    }
  };

  const handleFocus = () => {
    setTouched(false);
  };

  let error = touched && value === "";

  const handleChange = (event: SelectChangeEvent<string | number>) => {
    setValue(event.target.value as string | number);
    if (onChange) {
      onChange(event);
    }
  };

  inputLabel = inputLabel + (is_required ? "*" : "");

  return (
    <Box
      sx={{ minWidth: 150, ...sx}}
      className={error ? "custom-select-error" : "custom-select"}
    >
      <FormControl
        fullWidth
        error={touched && is_required && value === ""}
      >
        {inputLabel && <InputLabel id={`${id}-label`}>{inputLabel}</InputLabel>}
        <Select
          labelId={`${id}-label`}
          id={id}
          value={value}
          label={label}
          onChange={handleChange}
          onBlur={handleBlur}
          onFocus={handleFocus}
          MenuProps={{
            PaperProps: {
              sx: {
                width: "auto",
                textAlign: "center"
              },
            },
          }}
          {...props}
          sx={{width: "100%"}}
        >
          {items.map((item) => (
            <MenuItem key={item.value.toString()} value={item.value.toString()}
                      sx={{width: "100%", display: "flex",
                        justifyContent: "center",
                        backgroundColor: value.toString() === item.value.toString() ? 'var(--naturGreen) !important' : 'transparent',
                      transition: 'background-color 0.15s ease-in-out', '&:hover': {backgroundColor: 'var(--primary-color)',},}}>
              {item.label}
            </MenuItem>
          ))}
        </Select>
        {manualError && <Box sx={{ color: "error.main" }}>{errorText}</Box>}
      </FormControl>
    </Box>
  );
};
export default CustomSelect;
